import {makeStyles} from '@material-ui/core'
import {tableHeadColor} from "../variables"

const useStyles = makeStyles((theme) => ({
  main: {
    minHeight: '100vh',
  },
  paper: {
    marginTop: theme.spacing(8),
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
  },
  form: {
    width: '100%', // Fix IE 11 issue.
    marginTop: theme.spacing(1),
  },
  headRow: {
    backgroundColor: tableHeadColor,
    color:'white',
  },
  headCell: {
    color: 'white',
    fontFamily: 'Montserrat',
    fontSize:'1.2rem',
  },
  tableRow: {
    '&:hover':{
      backgroundColor:'lightGrey',
      cursor:'pointer',
    }
  },
  tableCell: {
    fontFamily: 'Montserrat',
    fontSize:'1.1rem',
  },
  tableContainer: {
    marginTop:'2rem',
  },
  verTodos: {
    width: '40%',
  },

}));

export default useStyles
